import React, { useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '../../../styles'
import { ButtonBase } from '@material-ui/core'
import Icon from '../../../components/icon/Icon'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import { ModelQuestion } from '../../../types/faq/faq_model'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import iconsEnum from '../../../enums/iconsEnum'
import { useMediaQuery } from 'react-responsive'

const ICON_RIGHT: string = iconsEnum.Right
const ICON_DOWN: string = iconsEnum.Down

const Accordion = withStyles({
	root: {
		boxShadow: 'none',
		'&$expanded': {
			margin: 0
		}
	},
	expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
	root: {
		padding: 0,
		'&$expanded': {
			minHeight: 0
		}
	},
	content: {
		display: 'flex',
		alignItems: 'center',
		margin: '20px 0px 20px 0px',
		'&$expanded': {
			margin: '20px 0px 0px 0px'
		},
		'& span': {
			textAlign: 'start'
		}
	},
	expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles({
	root: {
		padding: '0px 0px',
		margin: '13px 0px 20px 25px'
	}
})(MuiAccordionDetails)

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		iconQuestion: {
			fill: theme.palette.accessibility.main
		},
		answerDiv: {
			color: theme.palette.blue['50']
		},
		questionText: {
			marginLeft: '13px',
			color: theme.palette.blue.main
		}
	}
))

interface AcceptingProps {
	parentExpanded: boolean,
}

type QuestionProps = ModelQuestion & AcceptingProps

const Question: React.FC<QuestionProps> = (
	{
		question, response, parentExpanded
	}
) => {
	const classes = useStyle()
	const [childExpand, setChildExpand] = React.useState(false)
	const [icon, setIcon] = React.useState(ICON_RIGHT)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const questionTextClass = classNames(
		isLargeScreen ? [classes.title4] : [classes.title5],
		classes.questionText
	)

	const answerDivClass = classNames(
		isLargeScreen ? [classes.text1] : [classes.text2],
		classes.answerDiv
	)
	const handleExpand = () => (event: React.ChangeEvent<{}>, expanded: boolean) => {
		setChildExpand(expanded)
		if (expanded) {
			setIcon(ICON_DOWN)
		} else {
			setIcon(ICON_RIGHT)
		}
	}

	useEffect(() => {
		if (childExpand && !parentExpanded) {
			setChildExpand(false)
			setIcon(ICON_RIGHT)
		}
	}, [parentExpanded, childExpand])

	return (
		<Accordion expanded={childExpand} onChange={handleExpand()}>
			<AccordionSummary>
				<ButtonBase>
					<Icon icon={icon} size={12} className={classes.iconQuestion} />
				</ButtonBase>
				<span className={questionTextClass}>
					{question}
				</span>
			</AccordionSummary>
			<AccordionDetails>
                <span className={answerDivClass}>
                    {response}
                </span>
			</AccordionDetails>
		</Accordion>
	)
}
export default Question
